import Vue from 'vue';
import { EmojiMap, GetEmoji, EmojiCode } from '@/core/constants';

function escapeSpecialChars(regex: string) {
    return regex.replace(/([()[{*+.$^\\|?])/g, '\\$1');
}

function emojiEvent(event: any) {
    if (!event?.target?.value) return;

    for (const i in EmojiMap) {
        const regex = new RegExp(escapeSpecialChars(i), 'gim');
        event.target.value = event.target.value.replace(regex, GetEmoji(i as EmojiCode));
    }
}

Vue.directive('emojis', {
    bind: function(el: any) {
        el.addEventListener('input', emojiEvent, true);
    },
    unbind: function(el: any) {
        el.removeEventListener('input', emojiEvent, true);
    }
});
